const CORRELATION_ID_KEY = 'correlation_id';

export const setCorrelationId = (id: string | null) => {
  if (id === null) {
    return removeCorrelationId();
  }
  localStorage.setItem(CORRELATION_ID_KEY, id);
};

export const removeCorrelationId = () => {
  localStorage.removeItem(CORRELATION_ID_KEY);
};

export const getCorrelationId = () => {
  return localStorage.getItem(CORRELATION_ID_KEY) || null;
};
